import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Helpers } from "../../../helpers";
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { User, AuthenticationService } from '../../shared';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl } from '@angular/forms';

@Component({
  selector: 'change-password',
  templateUrl: 'change-password.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ChangePassword implements OnInit {

  password;
  newPassword;
  confirm;
  changePasswordForm;
  user: User;

  constructor(
    private _authenticationService: AuthenticationService,
    private _toastr: ToastrService,
    public dialogRef: MatDialogRef<ChangePassword>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _router: Router) {
  }

  ngOnInit() {
    this.changePasswordForm = new FormGroup({
      'currentPassword-input': new FormControl("", [
      ]),
      'password-input': new FormControl("", [
      ]),
      'newPasswordConfirmation-input': new FormControl("", [
      ])
    });
  }

  onSubmit(password) {
    Helpers.setLoading(true);
    password = {
      currentPassword: password['currentPassword-input'],
      newPassword: password['password-input'],
      newPasswordConfirmation: password['newPasswordConfirmation-input']
    }
    this._authenticationService.changePassword(password).subscribe(data => {
      this._toastr.success("Password changed successfully");
      Helpers.setLoading(false);
      this.dialogRef.close();
    }, error => {
      this._toastr.error("Error changing password", JSON.stringify(error._body));
      Helpers.setLoading(false);
    });

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
